import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import Pagination from "react-js-pagination";
import axios from "axios";
import { GroupContainer, NoData } from "./component/styled/common";
import GroupList from "./component/common/groupList";
import PageInfo from "./component/common/pageInfo";
import Search from "./component/common/search";

const MyGroup = () => {
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data[0]);

  const [page, setPage] = useState(1);
  const [my, setMy] = useState([]);
  const [total, setTotal] = useState(0);
  const [searched, setSearched] = useState("");

  useEffect(() => {
    if (!user) {
      navigate("/group/login");
    }
    getGroup();
  }, []);

  // 모임 조회
  const getGroup = async (num = 1) => {
    const pageSize = 12;
    const pageNumber = num - 1;

    const url = "/api/groupCondList";
    const body = {
      mberNo: user.mberNo,
      delYn: "N",
      offset: pageNumber * pageSize,
      pageNumber: pageNumber,
      pageSize,
      paged: true,
    };

    if (searched) {
      body.groupName = searched;
    }

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        console.log(res.data);
        setMy(res.data.content);
        setTotal(res.data.totalElements);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const changePage = (page) => {
    setPage(page);
    getGroup(page);
  };

  const handleSearch = () => {
    setPage(1);
    getGroup();
  };

  return (
    <GroupContainer>
      <div className="inner">
        <PageInfo title="MOIM - 협력과 소통의 공간" />
        <Search
          placeholder="모임명을 검색해주세요."
          searched={searched}
          setSearched={setSearched}
          handleSearch={handleSearch}
        />
        {my && my.length > 0 ? (
          <GroupList data={my} type="my" />
        ) : (
          <NoData>가입된 모임이 존재하지 않습니다.</NoData>
        )}
        {my && my.length > 0 && (
          <Pagination
            activePage={page}
            itemsCountPerPage={12}
            totalItemsCount={total}
            pageRangeDisplayed={5}
            prevPageText={"‹"}
            nextPageText={"›"}
            onChange={changePage}
          />
        )}
      </div>
    </GroupContainer>
  );
};

export default MyGroup;
